import { NextDisplayView } from '../../login-authentication-screen/models/login-credentials.interface';

export interface unlockAccountView {
  unlockYourAccountView: {
    headerSubTitle: string;
    headerTitle: string;
    message: {
      modal: string;
      wfp: string;
    };
    nextDisplayView: NextDisplayView;
    logoUrl: string;
    altText: string;
    wifiPortal: boolean;
  };
}
